import { render, staticRenderFns } from "./CustomerCreateOrEdit.vue?vue&type=template&id=cdc56cfc&"
import script from "./CustomerCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports